import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutes'
})
export class MinutesPipe implements PipeTransform {

  transform(value: any): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var minutes = Math.floor(sec_num / 60);

    return minutes > 9 ? `${minutes}` : `0${minutes}`;
  }

}
